export default {"src":"/_next/static/media/Triangle.d0391778.svg","height":43,"width":172,"blurWidth":0,"blurHeight":0};